
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { RequestActions } from "./RequestActions";
import { RequestInfo } from "./RequestInfo";
import { GroupLeaderRequest } from "@/types/admin-requests";

interface RequestCardProps {
  request: GroupLeaderRequest;
  processingId: string | null;
  onApprove: (request: GroupLeaderRequest) => Promise<void>;
  onReject: (request: GroupLeaderRequest) => Promise<void>;
  onDelete: (request: GroupLeaderRequest) => Promise<void>;
  onSendInvitation: (request: GroupLeaderRequest) => Promise<void>;
  onResetPassword?: (request: GroupLeaderRequest) => Promise<void>;
}

export const RequestCard = ({
  request,
  processingId,
  onApprove,
  onReject,
  onDelete,
  onSendInvitation,
  onResetPassword,
}: RequestCardProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">
          {request.full_name}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid gap-4">
          <RequestInfo request={request} />

          <RequestActions
            request={request}
            processingId={processingId}
            onApprove={onApprove}
            onReject={onReject}
            onDelete={onDelete}
            onSendInvitation={onSendInvitation}
            onResetPassword={onResetPassword}
          />
        </div>
      </CardContent>
    </Card>
  );
};
